export default "__VITE_ASSET__uJsrE22Q__"